import React from 'react';
import CorePage from '../../../views/core/CorePage';
import $ from 'jquery';

// ES6 class-style
class Blog extends CorePage {
	constructor(props){
		super(props)
		this.state = {lessonUrl:null}
		this.setContentSize = this.setContentSize.bind(this);
	}

	componentDidMount() {	
		//console.log("componentDidMount")
		var me =  this;	
		$(window).resize(function(){
			me.setContentSize();
		});

		this.setState({
			lessonUrl:me.getUrlFor("BLOG_URL")
		})

		$("body").css({overflowY:"hidden"});
		
		this.setContentSize();
	}

	componentWillUnmount(){
		//console.log("componentWillUnmount")
		$("body").css({overflowY:"auto"});
	}

	setContentSize()
	{
		var me = this;
		//
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      		//
      		$("#contentIFrame").css("visibility","hidden");
        	setTimeout(function()
        	{
        		$("#contentIFrame").css("visibility","visible");
        		me.resizeCall();
        	},1500);
        	//
    	}
		me.resizeCall();
	}
	//
	resizeCall()
	{
		//
		try
		{
			$("#contentIFrame").css({
				width:window.innerWidth,
				height:window.innerHeight-55,
			});			
		}catch(e)
		{
		}
	}
	
	sendDocHeightMsg() {
	    var ht = this.getDocHeight();
	    window.postMessage( JSON.stringify( {'docHeight': ht} ), '*' );
	    //parent.postMessage( JSON.stringify( {'docHeight': ht} ), 'http://www.your-domain.com' );
	}
	
	getDocHeight(doc) {
	    doc = doc || document;
	    console.log(doc);
	    // from http://stackoverflow.com/questions/1145850/get-height-of-entire-document-with-javascript
	    var body = doc.body, html = doc.documentElement;
	    var height = Math.max( body.scrollHeight, body.offsetHeight, 
	        html.clientHeight, html.scrollHeight, html.offsetHeight );
	    return height;
	}

  render() {
	var me = this;
  	return(
		<div> 
		<div id="blogCont" style={{overflow:'hidden'}}>
		<iframe 
				id="contentIFrame"
				style={{width:'100%',height:'100%',marginTop:'55px'}}
				onLoad={() => {
					setTimeout(function()
			        	{		        		
			        		me.setContentSize();
			        	},1500);
				}} 
				ref="iframe" 
				src={this.state.lessonUrl}
				width="100%" 
				height="100%" 
				scrolling="yes" 
				frameBorder="0"	
				/>
				</div>
		</div> 
  	);
  }
}

export default Blog; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/Blog.js